import { FeatureFlag } from '../FeatureFlag';

/**
 * Loads symbol-key tables keys first and stitches their columns per visible symbol (ADR 0020,
 * DEC-ROLLOUT-001). Covers Results (Alpha Scans included), Search, Screener, Scanner, and Watchlist.
 * The server table computes only membership and order, and the widget's consumer-local column
 * table serves every other visible column. Market columns are meant to come from shared per-symbol
 * feed tables; until table-cpp-proxy's subscription cap changes, the column table serves them too
 * (DEC-TABLES-001).
 *
 * Open widgets follow changes at once in either direction (DEC-ROLLOUT-002). Each change recreates
 * the widget's server table.
 */
export const enableStitchedSymbolTables = new FeatureFlag({
    key: 'enable-stitched-symbol-tables',
    createdOn: '2026-10-13',
    defaultValue: false,
});
